var _a;
import { Frame } from './frames';
import { Orientation } from './orientation';
var devices = (_a = {},
    _a[Frame.AppleWatch42] = {
        width: 156,
        height: 195,
        padding: [126, 56, 126, 43],
    },
    _a[Frame.IPhoneX] = {
        width: 375,
        height: 812,
        borderRadius: 40,
        padding: [26, 29, 26, 29],
    },
    _a[Frame.IPhone6] = {
        width: 375,
        height: 667,
        padding: [109, 29, 107, 29],
    },
    _a[Frame.IPhone6Plus] = {
        width: 414,
        height: 736,
        padding: [126, 34, 120, 34],
    },
    _a[Frame.IPhone5C] = {
        width: 320,
        height: 568,
        padding: [119, 30, 119, 34],
    },
    _a[Frame.IPhone5] = {
        width: 320,
        height: 568,
        padding: [121, 30, 115, 34],
    },
    _a[Frame.IPhone4S] = {
        width: 320,
        height: 480,
        padding: [128, 26, 128, 29],
    },
    _a[Frame.Pixel4] = {
        width: 360,
        height: 760,
        padding: [48, 14, 26, 17],
        borderRadius: 36,
    },
    _a[Frame.Nexus5] = {
        width: 320,
        height: 569,
        padding: [77, 22, 88, 20],
    },
    _a[Frame.Lumia920] = {
        width: 320,
        height: 533,
        padding: [68, 40, 123, 37],
    },
    _a[Frame.IPad] = {
        width: 1024,
        height: 1366,
        padding: [54, 50, 50, 48],
        borderRadius: 16,
    },
    _a[Frame.IPadPro11] = {
        width: 834,
        height: 1194,
        padding: [50, 48, 46, 50],
        borderRadius: 10,
    },
    _a[Frame.Web] = {
        width: '100%',
        height: '100%',
        padding: [0, 0, 0, 0],
    },
    _a);
function rotate(dimensions) {
    // Rotate right
    var p = dimensions.padding;
    return {
        width: dimensions.height,
        height: dimensions.width,
        padding: [p[3], p[0], p[1], p[2]],
        borderRadius: dimensions.borderRadius,
    };
}
export function getFrameDimensions(frame, orientation) {
    var info = devices[frame];
    if (!info) {
        throw new Error("No such frame: ".concat(frame));
    }
    if (orientation === Orientation.Landscape) {
        return rotate(info);
    }
    return info;
}
